import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface EmailSettings {
  provider: string;
  fromAddress: string;
  fromName: string;
  replyTo: string | null;
  smtpHost: string | null;
  smtpPort: number;
  smtpSecure: boolean;
  smtpUser: string | null;
  hasSmtpPassword: boolean;
  hasApiKey: boolean;
  active: boolean;
  source: string;
}

export interface UpdateEmailSettingsInput {
  provider?: string;
  fromAddress?: string;
  fromName?: string;
  replyTo?: string | null;
  smtpHost?: string | null;
  smtpPort?: number;
  smtpSecure?: boolean;
  smtpUser?: string | null;
  smtpPassword?: string;
  apiKey?: string;
  active?: boolean;
}

export const emailSettingsApi = {
  async get(): Promise<EmailSettings> {
    return (await apiClient.get<ApiSuccess<EmailSettings>>('/email-settings')).data.data;
  },
  async update(input: UpdateEmailSettingsInput): Promise<EmailSettings> {
    return (await apiClient.put<ApiSuccess<EmailSettings>>('/email-settings', input)).data.data;
  },
  async test(toAddress: string): Promise<{ provider: string; status: string }> {
    return (await apiClient.post<ApiSuccess<{ provider: string; status: string }>>('/email-settings/test', { toAddress })).data.data;
  },
};
